/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PosOffersAddressDtoNG } from './PosOffersAddressDtoNG';
import type { SelectedOffersDTO } from './SelectedOffersDTO';

export type PosOfferReviewRequestDtoNG = {
    deliveryAddress?: PosOffersAddressDtoNG;
    paymentOption?: PosOfferReviewRequestDtoNG.paymentOption;
    selectedOffers?: Array<SelectedOffersDTO>;
};

export namespace PosOfferReviewRequestDtoNG {

    export enum paymentOption {
        MONTHLY_FEE = 'MONTHLY_FEE',
        TRANSACTION_FEE = 'TRANSACTION_FEE',
        FULL_PAYMENT = 'FULL_PAYMENT',
    }


}

